export const CHANNELS = Object.freeze({
    ALL: 'ALL',
    RETAIL: 'RETAIL',
    FBA: 'FBA',
    MFN: 'MFN',
    WD: 'WAREHOUSE_DEALS',
    AGS: 'GLOBAL_STORES',
    AGL: 'GLOBAL_LISTINGS',
    HAUL: 'HAUL',
});


// WEBPACK FOOTER //
// ./src/constants/channels.jsx